import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapMutations } from 'vuex'
//const Mark = require('mark.js');
import $ from 'jquery';
//import { buildPattern } from '@/util';
import * as types from '@/store/types'

@Component({
})
export default class Iframe extends Vue {

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    globalBusy!: (flag: boolean) => void

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    instance?: any;

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String }) src!: string;
    @Prop({ type: String, default: '' }) type!: string;
    @Prop({ type: Boolean, default: true }) full!: boolean;
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loaded() {
        /** ContextMenu Hide */
        const _window = window as Window;
        const _this = this;
        var frame = document.querySelector(
            '.searchable-iframe'
        ) as HTMLFrameElement;
        let contentDocument = frame.contentDocument as HTMLDocument;
        if (contentDocument) {
            if (
                Number(contentDocument.body.offsetHeight) < frame.offsetHeight
            ) {
                contentDocument.body.style.minHeight = `${frame.offsetHeight}px`;
            }

            contentDocument.body.addEventListener(
                'mouseup',
                (e) => {
                    _window.document
                        .querySelectorAll('.btnContextMenuClose')
                        .forEach((x) => {
                            (x as HTMLElement).click();
                        });
                },
                false
            );
        }

        /** Appointment, Contact Valid */
        if (contentDocument) {
            let $html = $('<div></div>');
            let $div = $(contentDocument).find('[data-key="Appointment"]');
            if (!$div.length) {
                $div = $(contentDocument).find('[data-key="Contact"]');
            }

            if ($div.length) {
                let buttonStyle =
                    'border: 1px solid #808080;background:none;cursor:pointer;padding: 5px 10px;';
                let dataKey = $div.attr('data-key') as
                    | 'Appointment'
                    | 'Contact'
                    | 'Exception';
                let itemid = $div.find('input[type="hidden"]').val() as string;
                let title = this.$t(
                    dataKey == 'Appointment'
                        ? 'message.W_Schedule_Schedule'
                        : 'message.W_Contact_Contact'
                ).toString();
                let $h1 = $(`<h1>${title}</h1>`);
                let $p = $(
                    `<p>${this.$t(
                        'message.M_Valid_MessageType'
                    ).toString()}</p>`
                );
                let $btnRestore = $(
                    `<button class="em-btn" style="color:red; margin-right: 5px;${buttonStyle}">${this.$t(
                        'message.M_Mail_MoveFormat'
                    )
                        .toString()
                        .replace('{0}', title)}</button>`
                );
                let $btnHardDelete = $(
                    `<button class="em-btn" style="color:green;${buttonStyle}">${this.$t(
                        'message.W_Mail_Delete'
                    ).toString()}</button>`
                );

                $html.append($h1);
                $html.append($p);
                $html.append($btnRestore);
                $html.append($btnHardDelete);
                if (dataKey == 'Appointment' || dataKey == 'Contact') {
                    $div.append($html);
                }
            }
        }

        const jqs = $('.searchable-iframe')
            .contents()
            .find('a')
            .off('click')
            .click(function(event) {
                window.open(event.target.href);
                event.preventDefault();
            });

        this.setIframeHeight();

        this.$emit('iframeLoading');
    }

    /**
     * 컨텐츠 크기와 일치하도록 IFrame 높이를 설정합니다.
     * @param $event
     */
    setIframeHeight($event?: any) {
        const ifrm = this.$refs.iframe as any;
        var doc = this.getIframeDocument();
        // ifrm.style.visibility = 'hidden';
        // ifrm.style.height = '10px'; // reset to minimal height ...
        // IE opt. for bing/msn needs a bit added or scrollbar appears
        ifrm.style.height = this.calcSize('Height', doc) + 'px';
        ifrm.style.width = this.calcSize('Width', doc) + 'px';
        ifrm.style.visibility = 'visible';
    }

    getIframeDocument() {
        const ifrm = this.$refs.iframe as any;
        var doc = ifrm.contentDocument
            ? ifrm.contentDocument
            : ifrm.contentWindow.document;
        return doc;
    }

    calcSize(target: string, doc: any) {
        doc = doc || document;
        // stackoverflow.com/questions/1145850/
        var body = doc.body,
            html = doc.documentElement;
        var size = Math.max(
            body[`scroll${target}`],
            body[`offset${target}`],
            html[`client${target}`],
            html[`scroll${target}`],
            html[`offset${target}`]
        );
        return size + 100;
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    mounted() {
        var context = document.querySelector('.searchable-iframe-wrapper');
        //this.instance = new Mark(context);
    }

    beforeDestroy() {
        //delete this.instance;
    }
}
